import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from "@mui/styles";
import { useParams } from "react-router-dom";
import {
    CoachProfileProvider,
    CoachProfileConsumer,
    AdminCoachProfileContext
} from "../../common/AdminCoachProfileContext";
import CoachProfileView from "./CoachProfileView";


const CoachProfileViewContainer = (props) => {
    let isViewMode = false;
    const routeParams = useParams();
    
    // Support both router params and dialog props
    const userName = props.dialogUsername || routeParams.userName;

    const [params, setParams] = useState(userName);

    useEffect(() => {
        setParams(userName)
    }, [userName])

    return (
        <CoachProfileProvider>
            <CoachProfileConsumer>
                {(props) => {
                    return (
                        <div>
                            <CoachProfileView params={params} />
                        </div>)
                }}
            </CoachProfileConsumer>
        </CoachProfileProvider>
    );
}

export default CoachProfileViewContainer 